import { useContext } from 'react';
import TextsContext from './TextsContext';

export default function useTexts() {
  return useContext(TextsContext).texts ?? {};
}
